import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnInit,
  Optional,
} from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import {
  ContainerItemModel,
  ContainerModel,
} from '@app/models/server/layout.model';
import { DragScrollType } from '@app/models/client/drag-scroll.type';
import { HttpClientService } from '@app/services/util-services/root-services/http-client.service';
import {
  AsyncPipe,
  DecimalPipe,
  NgOptimizedImage,
  NgTemplateOutlet,
  TitleCasePipe,
} from '@angular/common';
import { IntersectionObserverDirective } from '@app/components/directives/intersection-observer/intersection-observer.directive';
import { IsNotEmptyPipe } from '@app/components/pipes/is-not-empty/is-not-empty.pipe';
import { Router } from '@angular/router';
import { NEW_IMAGE_PLACEHOLDERS } from '@app/constants/app-settings';
import { IntersectionStatus } from '@app/components/directives/intersection-observer/from-intersection-observer';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-small-property-card-v2',
  templateUrl: './small-property-card-v2.component.html',
  styleUrls: ['./small-property-card-v2.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    DecimalPipe,
    IntersectionObserverDirective,
    IsNotEmptyPipe,
    NgOptimizedImage,
    TitleCasePipe,
    NgTemplateOutlet,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallPropertyCardV2Component implements OnInit {
  @Input() compData: {
    container: ContainerModel;
  };

  @Input() config: DragScrollType;
  showScrollContainer = false;

  containersData$: Observable<ContainerItemModel[]>;

  target: string = String('');
  placeHolderImage: string = NEW_IMAGE_PLACEHOLDERS?.hotel;

  visibilityStatus: IntersectionStatus;

  intersectionStatus = IntersectionStatus;

  isServer: boolean = this.b2bDeviceUtilService.isServer();

  hostWebsite: string = environment.hostWebsite;

  constructor(
    private httpClientService: HttpClientService,
    private b2bDeviceUtilService: B2bDeviceUtilService,
    private router: Router,
    @Optional() @Inject('WINDOW') private window: any,
  ) {
    this.target = this.b2bDeviceUtilService.isDesktop() ? '_blank' : '';
  }

  ngOnInit(): void {
    this.initApi();
  }

  initApi() {
    this.containersData$ = this.httpClientService
      ?.getDynamicContainersData(
        this.compData?.container?.apiURL,
        this.compData?.container?.isCacheEnabled,
        this.compData?.container?.key,
        this.compData?.container?.apiRequestBody,
        null,
        true,
      )
      .pipe(
        switchMap((containers: ContainerModel[]) => {
          if (containers?.length === 1) {
            return of(containers[0]?.data);
          } else {
            return of([]);
          }
        }),
      );
  }

  onVisibilityChanged(status: IntersectionStatus) {
    this.visibilityStatus = status;
  }

  onCardClick(container: ContainerItemModel): void {
    if (container?.newNavigationURL) {
      const link = this.router.serializeUrl(
        this.router.createUrlTree([container?.newNavigationURL], {
          queryParams: container.queryParamObject,
        }),
      );

      if (this.window) {
        this.window.open(link, this.target);
      }

      /*this.router
        .navigate([container?.newNavigationURL], {
          queryParams: container.queryParamObject,
        })
        .then();*/
    }
  }

  /*  getQueryString(container: ContainerModel): string {
      let queryString: string;

      if (this.compData.container.queryParamObject) {
        const queryParamObject = JSON.parse(
          JSON.stringify(this.compData.container.queryParamObject),
        );
        if (value) {
          queryParamObject[key] = value;
        }
        queryString = convertObjectToQueryString(queryParamObject);
      }

      return queryString;
    }*/
}
